import { render, staticRenderFns } from "./TechnicalSupportPanel.vue?vue&type=template&id=3b703c57"
import script from "./TechnicalSupportPanel.vue?vue&type=script&lang=js"
export * from "./TechnicalSupportPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports